<template>
  <div
    v-if="slidePosts !== undefined && slidePosts.length > 0"
    class="swiper-posts"
    :class="{ 'swiper-posts--loading': loading }">
    <div
      :class="{'swiper-posts__title--middlebar': category === 'All'}"
      class="swiper-posts__title">
      <span v-html="overlineTitle"></span>
      <p v-html="subTitle" />
    </div>
    <div
      v-swiper-posts="slidePosts"
      class="swiper-container" >
      <div class="swiper-wrapper">
        <!-- Slides -->
        <div
          :class="{'swiper-slide--effect': $_postHasFilterEffect(slide.fields.category)}"
          class="swiper-slide"
          v-lazy-container="{ selector: 'img' }"
          v-for="(slide, index) of slidePosts"
          :key="index">
            <div class="swiper-slide__img-container">
              <img
                :data-src="slide.fields.image.fields.file.url"
                :data-loading="lazyLoading"
                :alt="slide.fields.image.fields.description"
                :width="slide.fields.image.fields.file.details.image.width"
                :height="slide.fields.image.fields.file.details.image.height">
              <div 
                v-if="$_postHasFilterEffect(slide.fields.category)"
                class="swiper-slide--effect__after">
              </div>
            </div>
            <div class="swiper-posts__text-area">
              <p v-html="slide.fields.title" />
              <router-link
                :to="{ name: `${lang}.single-post`, params: { slug: slide.fields.slug } }"
                class="glaxi__link">
                  {{ $t('common.discover') }}
              </router-link>
            </div>
        </div>
        <!-- Fine Slides -->
      </div>

      <!-- Operations -->
      <div class="swiper-operations swiper-operations--white">
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import swiper from './swiper'

export default {
  name: 'SwiperPosts',
  mixins: [swiper],
  data: () => ({
    loading: true,
    lazyLoading: require('@/assets/lazy/post.png')
  }),
  props: {
    overlineTitle: {
      type: String,
      required: false
    },
    subTitle: {
      type: String,
      required: false
    },
    currentSlug: {
      type: String,
      default: ''
    },
    category: {
      type: String,
      default: 'All'
    },
    shownPosts: {
      type: Number,
      default: () => 12
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'blogPosts'
    ]),
    ...mapGetters([
      'lang'
    ]),
    slidePosts: {
      get () {
        if (this.loading) return undefined
        if (this.category === 'All') return this.blogPosts.slice(0, this.shownPosts - 1)
        if (this.category !== 'All') {
          return this.blogPosts
            .filter(blogPost => blogPost.fields.category === this.category)
            .filter(blogPost => blogPost.fields.slug !== this.currentSlug)
            .slice(0, this.shownPosts - 1)
        }
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadBlogPosts'
    ]),
    $_postHasFilterEffect(category) {
      if (category === 'Live from') return false
      return true
    },
    async loadData () {
      this.loading = true
      try {
        await this.loadBlogPosts()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./swiper.scss";
</style>
